module.exports = __webpack_public_path__ + "img/pad-fill-profile-goal-slide1.5509ebec.gif";